import {Injectable} from '@angular/core';
import * as Handlebars from 'handlebars';

// import { LocationDataProcessingService } from './location-data-processing.service';

@Injectable({
  providedIn: 'root'
})
export class HandlebarsService {
  constructor() {}

  compileTemplate(source: string, context: any): string {
    const template = Handlebars.compile(source);

    return template(context);
  }

}
